import { Vue, Component } from "vue-property-decorator";
import RequestButtonFxd from '@/components/request-button/index.vue';
import RequestButton from '@/components/request-button/parts/request-button.vue';
import TrialButton from '@/components/trial-button/index.vue';

@Component({
  components: {
    RequestButtonFxd,
    RequestButton,
    TrialButton
  }
})

export default class PageRemai extends Vue {

  scrollExplore(){

    const scrollSection: any = this.$refs.scrollSection

    if (scrollSection){
      scrollSection.scrollIntoView({behavior: 'smooth'});
    }

  }

  mounted(){
    setTimeout(() => {
      document.documentElement.setAttribute('style', 'overflow-y:hidden');

    }, 200)

    console.log('overflowYoverflowY', document.documentElement.style.overflowY )
  }

  beforeDestroy() {
    document.documentElement.setAttribute('style', 'overflow-y:scroll');


  }
}